module.exports = __webpack_public_path__ + "static/media/CheckPaidScreen.646e8839.png";